/**
 * Static registry of the unit-number arrow icons.
 *
 * These were previously loaded with a template-literal specifier — a
 * `require(`@/components/common/unit-icons/${statusIcon}`)` in a template and an
 * `await import(`@/components/common/unit-icons/${id}.png`)` in useMapImages.
 * Neither is statically analysable, so Rollup cannot emit the assets.
 *
 * A static map is used rather than `import.meta.glob` because useMapImages.ts has
 * a Jest spec, and Jest cannot parse `import.meta`.
 *
 * Keys are filenames including the extension, matching what
 * UnitNumberStatusIcon's `statusIcon` computed already produces.
 */
import arrowActive from './arrow-active.png'
import arrowActiveNoop from './arrow-active-noop.png'
import arrowActiveOp from './arrow-active-op.png'
import arrowOffline from './arrow-offline.png'
import arrowOfflineNoop from './arrow-offline-noop.png'
import arrowOfflineOp from './arrow-offline-op.png'
import arrowStandby from './arrow-standby.png'
import arrowStandbyNoop from './arrow-standby-noop.png'
import arrowStandbyOp from './arrow-standby-op.png'

export const unitIcons: Readonly<Record<string, string>> = {
  'arrow-active.png': arrowActive,
  'arrow-active-noop.png': arrowActiveNoop,
  'arrow-active-op.png': arrowActiveOp,
  'arrow-offline.png': arrowOffline,
  'arrow-offline-noop.png': arrowOfflineNoop,
  'arrow-offline-op.png': arrowOfflineOp,
  'arrow-standby.png': arrowStandby,
  'arrow-standby-noop.png': arrowStandbyNoop,
  'arrow-standby-op.png': arrowStandbyOp,
}

/** Resolve by bare id (no extension), as used by the mapbox image loader. */
export function unitIconById(id: string): string | undefined {
  return unitIcons[`${id}.png`]
}
